"use client";
import React, { createContext, useContext, useState } from "react";
import { FormattedReportData } from "@/types/report";
import { ComparisonData, Evaluation } from "@/types";

interface ChatbotContextType {
  isOpen: boolean;
  toggleChatbot: () => void;
  initialMessage: { content: string } | null;
  setInitialMessage: (message: { content: string } | null) => void;
  reportData?: FormattedReportData;
  setReportData: (data: FormattedReportData | undefined) => void;
  comparisonData?: {
    evaluations: Evaluation[];
    comparison: ComparisonData;
  };
  setComparisonData: (data: { evaluations: Evaluation[]; comparison: ComparisonData; } | undefined) => void;
}

const ChatbotContext = createContext<ChatbotContextType | undefined>(undefined);

export function ChatbotProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState<{
    content: string;
  } | null>(null);
  const [reportData, setReportData] = useState<FormattedReportData>();
  const [comparisonData, setComparisonData] = useState<{
    evaluations: Evaluation[];
    comparison: ComparisonData;
  }>();

  const toggleChatbot = () => setIsOpen(!isOpen);

  return (
    <ChatbotContext.Provider value={{
      isOpen,
      toggleChatbot,
      initialMessage,
      setInitialMessage,
      reportData,
      setReportData,
      comparisonData,
      setComparisonData
    }}>
      {children}
    </ChatbotContext.Provider>
  );
}

export function useChatbot() {
  const context = useContext(ChatbotContext);
  if (context === undefined) {
    throw new Error("useChatbot must be used within a ChatbotProvider");
  }
  return context;
}
